import { Component, OnInit } from '@angular/core';
import { AppConfigService } from '@core/appconfig.service';
import { LogoParams } from '@models/logo-params';
import { CompanyCode } from '@shared/enums/company-code';
import { LogoHelpers } from '@shared/logo-helpers';

@Component({
  selector: 'zbp-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: false
})
export class PageNotFoundComponent implements OnInit {
  constructor(
    private appConfig: AppConfigService
  ) { }
  message: string = 'Page not found';
  title: string = '404';
  zbLink: string = 'https://www.zaner-bloser.com';
  logoParams: LogoParams;
  isZB: boolean = false;

  ngOnInit(): void {
    this.isZB = this.appConfig.loginBrand === CompanyCode.ZBPortal;
    this.logoParams = LogoHelpers.setLogoParams(this.isZB);
  }
}
